import styled from '@emotion/styled';
import React from 'react';

export type StyledButtonDivProps = React.HTMLAttributes<HTMLDivElement>;

const StyledButtonDiv = styled.div<StyledButtonDivProps>({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'flex-end',
  width: '100%'
});

export default StyledButtonDiv;
